import { render, staticRenderFns } from "./PoolView.vue?vue&type=template&id=47f53a5a"
import script from "./PoolView.vue?vue&type=script&lang=ts"
export * from "./PoolView.vue?vue&type=script&lang=ts"
import style0 from "./PoolView.vue?vue&type=style&index=0&id=47f53a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports